import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Simple, direct scroll to top on every route change
 * This is the most reliable approach
 */
const ScrollToTopOnRouteChange = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // Create a function that forces scroll to top
    const forceScrollToTop = () => {
      // Disable smooth scroll
      const html = document.documentElement;
      const body = document.body;
      const htmlOriginal = html.style.scrollBehavior;
      const bodyOriginal = body.style.scrollBehavior;
      
      html.style.scrollBehavior = 'auto';
      body.style.scrollBehavior = 'auto';
      
      // Multiple scroll methods
      window.scrollTo(0, 0);
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      
      const root = document.getElementById('root');
      if (root) {
        root.scrollTop = 0;
      }
      
      // Restore after scroll
      setTimeout(() => {
        html.style.scrollBehavior = htmlOriginal || '';
        body.style.scrollBehavior = bodyOriginal || '';
      }, 100);
    };

    // Execute immediately
    forceScrollToTop();

    // Also execute after a tiny delay to catch any async updates
    const timeout1 = setTimeout(forceScrollToTop, 0);
    const timeout2 = setTimeout(forceScrollToTop, 10);
    const timeout3 = setTimeout(forceScrollToTop, 50);
    const timeout4 = setTimeout(forceScrollToTop, 100);

    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
      clearTimeout(timeout3);
      clearTimeout(timeout4);
    };
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTopOnRouteChange;
